import type { Match } from '@/types';

export default function StatsCompare({ match }: { match: Match }) {
  if (match.stats.length === 0) {
    return (
      <div className="px-4 md:px-5 py-10 text-center">
        <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-3">
          <i className="ri-bar-chart-box-line text-xl"></i>
        </span>
        <p className="text-sm text-foreground-500">比赛尚未开始，暂无技术统计。</p>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-5 py-4 space-y-4">
      {match.stats.map((s) => {
        const total = s.home + s.away || 1;
        const homePct = Math.round((s.home / total) * 100);
        const awayPct = 100 - homePct;
        return (
          <div key={s.label}>
            <div className="flex items-center justify-between text-xs md:text-sm mb-1.5">
              <span className="font-heading font-bold text-foreground-900 tabular-nums w-12">{s.home}{s.unit}</span>
              <span className="text-foreground-500">{s.label}</span>
              <span className="font-heading font-bold text-foreground-900 tabular-nums w-12 text-right">{s.away}{s.unit}</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden flex justify-end">
                <span className="h-full rounded-full bg-primary-500" style={{ width: `${homePct}%` }}></span>
              </div>
              <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                <span className="h-full rounded-full bg-secondary-500" style={{ width: `${awayPct}%` }}></span>
              </div>
            </div>
          </div>
        );
      })}
      <div className="flex items-center justify-center gap-5 pt-1">
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <span className="w-3 h-3 rounded-sm bg-primary-500"></span>主队
        </span>
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <span className="w-3 h-3 rounded-sm bg-secondary-500"></span>客队
        </span>
      </div>
    </div>
  );
}